import clsx from 'clsx'
import { Button, Grid, NetworkIcon, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { Link } from 'react-router-dom'
import formatMoney from 'utils/formatMoney'
import useNetworkPalette from 'utils/hooks/useNetworkPalette'
import servicesCommonStyles from 'modules/Services/services.module.scss'
import styles from 'modules/Services/NetworksList/services-list.module.scss'
import { ROUTES } from 'constants/routes'
import HighRiskLabel from 'modules/Services/Network/subcomponents/HighRiskLabel'

const ConnectedListItem = ({ type, balance = null, display_balance = true }) => {
  const pathGen = useGeneratePathI18n()
  const { t } = useTranslation(['services'])

  const paletteClass = useNetworkPalette(type)

  return (
    <Grid
      gap={24}
      component={Link}
      to={pathGen(ROUTES.SERVICES_NETWORK, {
        networkType: type,
      })}
      className={clsx(
        styles['list__item'],
        styles['list__item_connected'],
        styles['list__item_connected-palette-' + paletteClass],
        'bg-network-' + type,
        servicesCommonStyles['palette_' + paletteClass],
      )}
    >
      <Grid fluid={false} wrap={false} direction={'row'} gap={16} alignItems={'center'}>
        <NetworkIcon
          dark={paletteClass === 'light'}
          rounded
          width={56}
          name={type}
          type={'unlinked'}
        />
        <Typography component={'div'} variant={'Subtitle-30'}>
          {t(`networks.${type}`)}
        </Typography>
        {type.match(/high-risk$/) && <HighRiskLabel />}
      </Grid>
      <Grid gap={16} direction={'column'} justifyContent={'between'}>
        {display_balance && balance && balance?.amount !== null ? (
          <Typography
            variant={'Body-Accent-40'}
            dangerouslySetInnerHTML={{
              __html: balance && formatMoney(balance.amount, balance.currency),
            }}
          />
        ) : (
          <Typography
            variant={'Body-Accent-40'}
            dangerouslySetInnerHTML={{
              __html: ' ',
            }}
          />
        )}
        <div>
          <Button
            grey={paletteClass === 'dark'}
            variant={'contrast'}
            size={'s'}
            noHover
            opacity={paletteClass === 'dark' ? 10 : 20}
          >
            {t('button.fund')}
          </Button>
        </div>
      </Grid>
    </Grid>
  )
}

ConnectedListItem.propTypes = {
  type: PropTypes.string,
  balance: PropTypes.object,
  bonus: PropTypes.number,
  display_balance: PropTypes.bool,
}
export default ConnectedListItem
